import React from 'react';
import { View } from '../../../components/Common/react-native-components';
import Discovery from '../components/Discovery';

const InsightsContainer = () => {

  return (
    <View style={{ padding: 20, background: '#fff' }}>
      <Discovery />
    </View>
  );
};


export default InsightsContainer;
